function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
export var FinalizationRegistryBasedCleanupTracking = /*#__PURE__*/ function() {
    "use strict";
    function FinalizationRegistryBasedCleanupTracking() {
        _class_call_check(this, FinalizationRegistryBasedCleanupTracking);
        this.registry = new FinalizationRegistry(function(unsubscribe) {
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        });
    }
    _create_class(FinalizationRegistryBasedCleanupTracking, [
        {
            key: "register",
            value: function register(object, unsubscribe, unregisterToken) {
                this.registry.register(object, unsubscribe, unregisterToken);
            }
        },
        {
            key: "unregister",
            value: function unregister(unregisterToken) {
                this.registry.unregister(unregisterToken);
            }
        },
        {
            // eslint-disable-next-line class-methods-use-this
            key: "reset",
            value: function reset() {}
        }
    ]);
    return FinalizationRegistryBasedCleanupTracking;
}();
